import { DataDeadZone, postMagnetKeyInfo } from '@libs/types/response'
import { MagnetDriver } from '../device'
import { DeviceProtocol } from '@hid/device/device_model'
import { jingtaiV2Driver } from '../jingtai_v2'
import { KeyFunction, KIO, KK, OutputMode, SetMagnetSenior, VK } from '@hid/define/define'
import { IADCSampleInfo, IRouteInfo, jingtaiV2Data, jingtaiV2MagnetModeConvert, jingtaiV2PerformanceInfo, jingtaiV2ResHigherKey, JingTaiV2SetMode, jingtaiV2SetPerformance } from '../data_conversion/jingtai_v2'
import { deviceManager } from '@hid/device/device_manager'
import { allKeysForDevice, HidFromKK, HIDFromVk, kkFromVK } from '@hid/define/define_fn'
import { generateMessageID } from '@libs/utils/tools'
import { fakeSocket } from '@hid/fakesocket/fakesocket'
import { TravelPostData } from '@hid/common/types'
import { MagnetSeniorType } from '@libs/types/enum'
import { defaultVK } from '@hid/define/define_keys'

export class jingtaiV2Magnet extends MagnetDriver {
  private shouldStop = false

  constructor(
    private DeviceHID: DeviceProtocol,
    private parent: jingtaiV2Driver,
  ) {
    super()
  }

  async startCalibration(): Promise<void> {
    await this.parent.musicIns.musicCapturePause()
    console.log(this.DeviceHID)
    await this.parent.deviceIns.calibrationStart().catch((e) => {
      console.error('calibrationStart error', e)
    })
  }

  async endCalibration(): Promise<void> {
    await this.parent.deviceIns.calibrationEnd().catch((e) => {
      console.error('calibrationEnd error', e)
    })
    await this.parent.musicIns.musicCaptureContinue()
  }

  private sendMessage<T>(type: number, data: T): void {
    fakeSocket.onmessage({
      data: JSON.stringify({
        ID: generateMessageID(),
        Type: type,
        Data: data,
        Error: null,
      }),
    } as MessageEvent)
  }

  async startTravels(): Promise<void> {
    await this.parent.musicIns.musicCapturePause()
    this.shouldStop = false
    const travelData: TravelPostData[] = []
    const ADSTravelData: TravelPostData[] = []
    const deviceKeys = allKeysForDevice(deviceManager.deviceID)

    deviceKeys.forEach((key) => {
      travelData.push({ Key: key, Value: 0 })
      ADSTravelData.push({ Key: key, Value: 0 })
    })
    const ROW_COUNT = 6

    while (!this.shouldStop) {
      for (let i = 0; i < ROW_COUNT; i++) {
        const result: IRouteInfo = (await this.parent.deviceIns.getRoute({ row: i })) as IRouteInfo

        const ADSResult: IADCSampleInfo = (await this.parent.deviceIns.getADCSample({ row: i })) as IADCSampleInfo
        result.data.forEach((item: number, index: number) => {
          const key = (result.row << 8) + index
          const foundIndex = travelData.findIndex((i) => i.Key == key)
          const foundIndexADS = ADSTravelData.findIndex((i) => i.Key == key)
          if (foundIndexADS !== -1) {
            ADSTravelData[foundIndexADS].Value = ADSResult.data[index]
          }
          if (foundIndex !== -1) {
            travelData[foundIndex].Value = item
          }
        })
        this.sendMessage(224, travelData)
        this.sendMessage(223, ADSTravelData)
      }
    }
  }
  async endTravels(): Promise<void> {
    this.shouldStop = true
    await this.parent.musicIns.musicCaptureContinue()
  }
  async syncKeysTravels(): Promise<void> {
    await this.parent.musicIns.musicCapturePause()
    const keys = allKeysForDevice(deviceManager.deviceID)
    const travels = this.parent.save.MagnetTravel
    const deadzoneList = this.parent.save.DeadZoneList

    //const setList: Map<KK, jingtaiV2PerformanceInfo> = new Map()

    for (let index = 0; index < keys.length; index++) {
      const key = keys[index]
      const travel = travels.get(key)
      const deadZone = deadzoneList.get(key)
      if (travel && deadZone) {
        let mode = 0
        if (travel.QuickTriggerPressNum > 0 || travel.QuickTriggerReleaseNum > 0) {
          mode = 1
        }
        let setData = {
          mode: mode,
          row: jingtaiV2Data.getRow(key),
          col: jingtaiV2Data.getCol(key),
          pressDeadStroke: this.formatTravel(deadZone.Top),
          releaseDeadStroke: this.formatTravel(deadZone.Bottom),
          axis: 0,
          calibrate: 0,
          rtFirstTouch: 0.5,
          rtPress: 0.3,
          rtRelease: 0.3,
          normalPress: 2,
          normalRelease: 2,
        } as jingtaiV2SetPerformance

        if (mode == 1) {
          setData.rtFirstTouch = this.formatTravel(travel.PressNum)
          setData.rtPress = this.formatTravel(travel.QuickTriggerPressNum)
          setData.rtRelease = this.formatTravel(travel.QuickTriggerReleaseNum)
        } else {
          setData.normalPress = this.formatTravel(travel.PressNum)
          setData.normalRelease = this.formatTravel(travel.ReleaseNum)
        }

        await this.parent.deviceIns.setPerformance(setData)
      }
    }
    await this.parent.musicIns.musicCaptureContinue()
  }

  // TODO: 死区放在和行程一起设置
  async syncKeysDeadZone(): Promise<void> {}

  private setTrPSx(data: KeyFunction) {
    let res = 0
    for (let index = 0; index < data.length; index++) {
      if (index == 0) {
        if (data[index] == 1) {
          res |= 0x01 << 0
        }
        if (data[index] == 2) {
          res |= 0x01 << 1
        }
      } else if (index == 3) {
        if (data[index] > 0) {
          res |= 0x01 << 7
        }
      } else if (index == 1) {
        if (data[index] == 1) {
          res |= 0x01 << 2
        }
        if (data[index] == 2) {
          res |= 0x01 << 2
          res |= 0x01 << 3
          res |= 0x01 << 4
        }
        if (data[index] == 3) {
          res |= 0x01 << 2
        }
      } else if (index == 2) {
        if (data[index] == 1) {
          res |= 0x01 << 5
        }
        if (data[index] == 2 || data[index] == 3) {
          res |= 0x01 << 5
          res |= 0x01 << 6
        }
      }
    }
    return res
  }
  // KEM Mode 转换
  private KMEModeConversion(KMEMode: number[]): number {
    const [a = 0, b = 0] = KMEMode
    if (a == 0 && b == 1) {
      return 1
    } else if (a == 1 && b == 0) {
      return 2
    } else if (a == 1 && b == 1) {
      return 3
    }
    return 0
  }
  private async setDKS(data: Map<KK, SetMagnetSenior>): Promise<void> {
    for (const [item, value] of data) {
      const kcs: (VK | undefined)[] = []
      const trps: number[] = []
      const minTravel = Math.min(...value.Keys.map((key) => key.Travel))
      const maxTravel = Math.max(...value.Keys.map((key) => key.Travel))
      const dbs = [minTravel / 10, maxTravel / 10]
      value.Keys.forEach((key) => {
        key.KeyCode.forEach((code) => kcs.push(HIDFromVk(code as VK)))
        trps.push(this.setTrPSx(key.KeyFunction))
      })
      const param = {
        row: jingtaiV2Data.getRow(item),
        col: jingtaiV2Data.getCol(item),
        data: { kcs, trps, dbs },
      }
      await this.parent.deviceIns.setHigherKeyDKS(param).catch((err) => {
        console.error('setDKS error', err)
      })
    }
  }
  private async setMT(data: Map<KK, SetMagnetSenior>) {
    for (const [item, value] of data) {
      const kcs: (VK | undefined)[] = [] //第一位是单击，第二位是长按
      const time = value.MTDuration * 10
      for (let i = value.Keys.length - 1; i >= 0; i--) {
        const key = value.Keys[i]
        key.KeyCode.forEach((code) => kcs.push(HIDFromVk(code as VK)))
      }
      const param = {
        row: jingtaiV2Data.getRow(item),
        col: jingtaiV2Data.getCol(item),
        mode: 'MT',
        data: { time, kcs },
      }
      console.log('param', param)
      await this.parent.deviceIns.setHigherKeyMT(param).catch((err) => {
        console.error('setMT error', err)
      })
    }
  }
  private async setTGL(data: Map<KK, SetMagnetSenior>) {
    for (const [item, value] of data) {
      let kcs: VK | undefined = undefined
      const delay = value.DelayTime
      value.Keys.forEach((key) => key.KeyCode.forEach((code) => (kcs = HIDFromVk(code as VK))))
      const param = {
        row: jingtaiV2Data.getRow(item),
        col: jingtaiV2Data.getCol(item),
        mode: 'TGL',
        data: { delay, kcs },
      }
      await this.parent.deviceIns.setHigherKeyTGL(param).catch((err) => {
        console.error('setTGL error', err)
      })
    }
  }
  private async setMPT(data: Map<KK, SetMagnetSenior>) {
    for (const [item, value] of data) {
      const kcs: (VK | undefined)[] = []
      const dbs: number[] = []
      value.Keys.forEach((key) => {
        key.KeyCode.forEach((code) => kcs.push(HIDFromVk(code as VK)))
        dbs.push(this.formatTravel(key.Travel))
      })
      const param = {
        row: jingtaiV2Data.getRow(item),
        col: jingtaiV2Data.getCol(item),
        mode: JingTaiV2SetMode.MPT,
        data: { kcs, dbs },
      }
      await this.parent.deviceIns.setHigherKeyMPT(param).catch((err) => {
        console.error('setMPT error', err)
      })
    }
  }
  private async setEND(data: Map<KK, SetMagnetSenior>) {
    for (const [item, value] of data) {
      const kcs: (VK | undefined)[] = [HidFromKK(item as KK, deviceManager.deviceID)]
      const delay = value.DelayTime
      value.Keys.forEach((key) => key.KeyCode.forEach((code) => kcs.push(HIDFromVk(code as VK))))
      const param = {
        row: jingtaiV2Data.getRow(item),
        col: jingtaiV2Data.getCol(item),
        mode: 'END',
        data: { kcs, delay },
      }
      await this.parent.deviceIns.setHigherKeyEND(param).catch((err) => {
        console.error('setEND error', err)
      })
    }
  }

  private async setKME(data: Map<KK, SetMagnetSenior>) {
    for (const [item, value] of data) {
      let setKey: KK | undefined
      value.Keys.forEach((key) =>
        key.KeyCode.forEach((code) => {
          if (code && code > 0) {
            setKey = kkFromVK(code as VK, deviceManager.deviceID)
          }
        }),
      )
      const kcs: (VK | undefined)[] = []
      kcs.push(HidFromKK(item as KK, deviceManager.deviceID))
      kcs.push(HidFromKK(setKey as KK, deviceManager.deviceID))
      if (setKey == undefined) {
        throw new Error('setSOCD setKey is undefined')
      }
      const param = {
        row: jingtaiV2Data.getRow(item),
        col: jingtaiV2Data.getCol(item),
        row2: jingtaiV2Data.getRow(setKey),
        col2: jingtaiV2Data.getCol(setKey),
        mode: 'SOCD',
        socdMode: this.KMEModeConversion(value.KMEMode),
        delay: value.DelayTime,
        kcs,
      }
      await this.parent.deviceIns.setHigherKeySOCD(param).catch((err) => {
        console.error('setSOCD error', err)
      })
    }
  }
  // setHigherKeyRS: (param: HigherKeyParams) => Promise<{
  //         row: number;
  //         col: number;
  //         mode: number;
  //         data: {
  //             row2: number;
  //             col2: number;
  //             kcs: number[];
  //             delay: number;
  //         };
  //     }>;
  private async setRS(data: Map<KK, SetMagnetSenior>) {
    for (const [item, value] of data) {
      let setKey: KK | undefined
      value.Keys.forEach((key) =>
        key.KeyCode.forEach((code) => {
          if (code && code > 0) {
            setKey = kkFromVK(code as VK, deviceManager.deviceID)
          }
        }),
      )
      const kcs: (VK | undefined)[] = []
      kcs.push(HidFromKK(item as KK, deviceManager.deviceID))
      kcs.push(HidFromKK(setKey as KK, deviceManager.deviceID))
      if (setKey == undefined) {
        throw new Error('setRS setKey is undefined')
      }
      await this.parent.deviceIns
        .setHigherKeyRS({
          row: jingtaiV2Data.getRow(item),
          col: jingtaiV2Data.getCol(item),
          mode: 'RS',
          data: {
            row2: jingtaiV2Data.getRow(setKey),
            col2: jingtaiV2Data.getCol(setKey),
            kcs: kcs,
            delay: value.DelayTime,
          },
        })
        .catch((err) => {
          console.error('setRS error', err)
        })
    }
  }
  async syncSeniorkey(): Promise<void> {
    await this.parent.musicIns.musicCapturePause()
    const dksData = new Map<KK, SetMagnetSenior>()
    const mtData = new Map<KK, SetMagnetSenior>()
    const tglData = new Map<KK, SetMagnetSenior>()
    const mptData = new Map<KK, SetMagnetSenior>()
    const endData = new Map<KK, SetMagnetSenior>()
    const kmeData = new Map<KK, SetMagnetSenior>()
    const rsData = new Map<KK, SetMagnetSenior>()

    for (let index = 0; index < this.parent.save.Keys.length; index++) {
      const value = this.parent.save.Keys[index]
      if (value.Output.Mode != OutputMode.Magnet) continue

      //重置普通层
      this.resetFn0(value.Input.KK)

      const magnetData = this.parent.save.MagnetData.get(value.Output.DataIndex)
      if (magnetData == undefined) continue
      if (magnetData.KeyType == MagnetSeniorType.SeniorKeyTypeNone) continue
      switch (magnetData.KeyType) {
        case MagnetSeniorType.SeniorKeyTypeDKS:
          dksData.set(value.Input.KK, magnetData)
          break
        case MagnetSeniorType.SeniorKeyTypeMT:
          mtData.set(value.Input.KK, magnetData)
          break
        case MagnetSeniorType.SeniorKeyTypeTGL:
          tglData.set(value.Input.KK, magnetData)
          break
        case MagnetSeniorType.SeniorKeyTypeMPT:
          mptData.set(value.Input.KK, magnetData)
          break
        case MagnetSeniorType.SeniorKeyTypeEND:
          endData.set(value.Input.KK, magnetData)
          break
        case MagnetSeniorType.SeniorKeyTypeKME:
          kmeData.set(value.Input.KK, magnetData)
          break
        case MagnetSeniorType.SeniorKeyTypeRS:
          rsData.set(value.Input.KK, magnetData)
          break
      }
    }
    if (dksData.size > 0) {
      await this.setDKS(dksData)
    }
    if (mtData.size > 0) {
      await this.setMT(mtData)
    }
    if (tglData.size > 0) {
      await this.setTGL(tglData)
    }
    if (mptData.size > 0) {
      await this.setMPT(mptData)
    }
    if (endData.size > 0) {
      await this.setEND(endData)
    }
    if (kmeData.size > 0) {
      await this.setKME(kmeData)
    }
    if (rsData.size > 0) {
      await this.setRS(rsData)
    }
    await this.clearKME()

    await this.parent.musicIns.musicCaptureContinue()
  }

  async resetFn0(kk: KK) {
    const key: KIO = {
      Input: {
        KK: kk,
        WithFN: false,
        WithModifier: [],
      },
      Output: {
        Mode: OutputMode.Key,
        VK: defaultVK,
        DataIndex: 0,
        Extension: [],
      },
    }
    await this.parent.deviceIns.setKeyCode(jingtaiV2Data.setKey(key))
  }

  async clearKME(): Promise<void> {
    const keys = this.parent.resetKmeKeys
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index]
      await this.parent.delHigherKeyMode(key.Input.KK)
    }
    this.parent.clearKmeKeys()
  }
  async getKeysTravels(keys?: KK[]): Promise<postMagnetKeyInfo[]> {
    let res: postMagnetKeyInfo[] = []
    const data = await this.keysPerformanceInfo(keys)
    for (const [key, value] of data) {
      const keyMode = (await this.parent.deviceIns.getHigherKey({
        row: jingtaiV2Data.getRow(key),
        col: jingtaiV2Data.getCol(key),
      })) as jingtaiV2ResHigherKey
      res.push({
        Key: key,
        KeyType: jingtaiV2MagnetModeConvert(keyMode.mode),
        PressNum: value.mode == 1 ? this.formatTravel(value.rtFirstTouch, false) : this.formatTravel(value.normalPress, false),
        ReleaseNum: value.mode == 1 ? this.formatTravel(value.rtFirstTouch, false) : this.formatTravel(value.normalRelease, false),
        QuickTriggerPressNum: value.mode == 1 ? this.formatTravel(value.rtPress, false) : 0,
        QuickTriggerReleaseNum: value.mode == 1 ? this.formatTravel(value.rtRelease, false) : 0,
      })
    }

    return res
  }

  async readOrSetDeadZone(_isWrite: boolean, _value?: [number, number]): Promise<[number, number]> {
    return [0, 0]
  }

  async getKeysDeadZone(keys?: KK[]): Promise<Map<KK, DataDeadZone>> {
    const data = await this.keysPerformanceInfo(keys)
    const res = new Map<KK, DataDeadZone>()
    for (const [key, value] of data) {
      res.set(key, {
        Top: this.formatTravel(value.pressDeadStroke, false),
        Bottom: this.formatTravel(value.releaseDeadStroke, false),
      })
    }
    return res
  }

  private performanceInfo: Map<KK, jingtaiV2PerformanceInfo> = new Map()
  private async keysPerformanceInfo(keys?: KK[]) {
    await this.parent.musicIns.musicCapturePause()
    if (this.performanceInfo.size == 0) {
      keys = allKeysForDevice(deviceManager.deviceID)
      for (let index = 0; index < keys.length; index++) {
        const key = keys[index]
        const data = (await this.parent.deviceIns.getPerformance({ row: jingtaiV2Data.getRow(key), col: jingtaiV2Data.getCol(key) })) as jingtaiV2PerformanceInfo
        //console.log(data)
        this.performanceInfo.set(key, data)
      }
      setTimeout(() => {
        this.performanceInfo.clear()
      }, 2000)
    }
    await this.parent.musicIns.musicCaptureContinue()
    return this.performanceInfo
  }

  formatTravel(value: number, isSet: boolean = true) {
    if (isSet) {
      return value / 1000
    }
    return value * 1000
  }

  async DemoDebug(): Promise<void> {}

  destroy() {}
}
